import Chart from 'chart.js/auto';
import ApplicationController from './application_controller';

const pluginMap = {
  'doughnut-center-label': {
    id: 'centerLabel',
    beforeDraw(chart, args, options) {
      const { ctx, chartArea: { top, width, height } } = chart;

      ctx.save();

      ctx.fillRect(width / 2, top + (height / 2), 0, 0); // チャート描画部分の中央を指定
      // フォントのスタイル指定
      ctx.font = 'bold 36px Roboto';
      ctx.fillStyle = '#1d1825';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      ctx.fillText(options.text, width / 2, top + (height / 2));
    },
    defaults: {
      text: '',
    },
  },
};

// Connects to data-controller="chart"
export default class extends ApplicationController {
  static values = {
    type: String,
    data: String,
    options: { type: String, default: '{}' },
    plugins: String,
  };

  connect() {
    super.connect();
    this.show();
  }

  show() {
    const plugins = pluginMap[this.pluginsValue];

    new Chart(this.element, {
      type: this.typeValue,
      data: JSON.parse(this.dataValue),
      options: JSON.parse(this.optionsValue),
      plugins: plugins ? [plugins] : [],
    });
  }
}
